import type { ReactNode } from 'react';
import styled from 'styled-components';

import { cardBackround } from '@/styles/shared';

export const SitemapWrapper = styled.div`
  ${cardBackround};
  padding: 12px;
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 60px auto 80px;

  @media ${({ theme }) => theme.media.tablet} {
    padding: 40px 50px;
  }

  h2 {
    margin-top: 60px;
    font-size: 24px;
  }
`;

export const SitemapSection = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  margin: 20px 0 35px 0;

  @media ${({ theme }) => theme.media.desktop} {
    grid-template-columns: 1fr 1fr;
  }

  a {
    color: ${({ theme }) => theme.palette.dark};

    &:hover {
      color: ${({ theme }) => theme.palette.primary};
    }
  }
`;

export const SitemapItem = styled.li<{
  children: ReactNode;
}>`
  padding-left: 10px;
  width: 100%;

  p {
    font-size: 18px;
  }
`;
